export interface RetryOptions {
  count?: number
  cooldown?: number
  delta?: number
}

type PromiseFn<T> = () => Promise<T>

async function retryAsync<T>(
  promiseFn: PromiseFn<T>,
  options?: RetryOptions,
): Promise<T> {
  let { count: tries = 1, cooldown = 500, delta = 500 } = options || {}
  let lastException

  tries = tries | 0
  cooldown = cooldown | 0
  delta = delta | 0

  while (tries > 0) {
    try {
      return await promiseFn()
    } catch (e) {
      lastException = e
      tries -= 1
      await timeoutPromise(cooldown)
      cooldown += delta
      delta += delta
    }
  }

  throw lastException
}

function timeoutPromise(delayMsec: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(() => resolve(), delayMsec)
  })
}

export default retryAsync
